// extracted by mini-css-extract-plugin
export var active = "styles-module--active--12723";
export var copyrightText = "styles-module--copyrightText--016d5";
export var dropdownIcon = "styles-module--dropdown-icon--d6ad5";
export var footerBottomMenu = "styles-module--footerBottomMenu--c8b2f";
export var footerCustomLinHeight1 = "styles-module--footerCustomLinHeight1--facd4";
export var footerCustomLinHeight2 = "styles-module--footerCustomLinHeight2--55d62";
export var footerTypeBottomSectionOnly = "styles-module--footerTypeBottomSectionOnly--00541";
export var footerTypeDefault = "styles-module--footerTypeDefault--f3dd5";
export var footerTypeMinimal = "styles-module--footerTypeMinimal--24579";
export var languageBtn = "styles-module--language-btn--84a2d";
export var languageOptions = "styles-module--language-options--81e9a";
export var languageSwitcher = "styles-module--language-switcher--ba964";
export var subFooter = "styles-module--subFooter--1fbe6";